import { ADS_DOMAIN } from '#/utils/const';

export const APIs = {
  app: {
    videoTemplates: `${ADS_DOMAIN}/appstore/api/partner-video-templates/get`,
  },
  user: {
    get: `${ADS_DOMAIN}/marketing_api/api/login_context/get/`,
    checkEmail: `${ADS_DOMAIN}/marketing_api/api/developer/check_email/`,
  },
  aiSkillHub: {
    skillGet: `${ADS_DOMAIN}/marketing_api/api/ai_skill_hub/skill/get/`,
    skillDemoGet: `${ADS_DOMAIN}/marketing_api/api/ai_skill_hub/skill/demo/get/`,
    skillDetailGet: `${ADS_DOMAIN}/marketing_api/api/ai_skill_hub/skill/detail/get/`,
    skillDownloadGet: `${ADS_DOMAIN}/marketing_api/api/ai_skill_hub/skill/download/get/`,
    skillInstall: `${ADS_DOMAIN}/marketing_api/api/ai_skill_hub/skill/install/`,
  },
  // https://haapi.byteintl.net/v3/business/interface?businessId=1784365398779970&spaceId=1783157889531906
  auth: {
    isAuthorizedProd: `${ADS_DOMAIN}/app_center/v1.0/auth/is_authorized/`,
    isAuthorizedTest: `${ADS_DOMAIN}/app_center/v1.0/auth/test/is_authorized/`,
  },
  // https://haapi.byteintl.net/v3/business/interface?businessId=1783274541207553&spaceId=1783157889531906
  apps: {
    installedApps: `${ADS_DOMAIN}/app_center/v1.0/apps/installed/get/`,
    spotlightApps: `${ADS_DOMAIN}/app_center/v1.0/apps/spotlight/get/`,
    installProd: `${ADS_DOMAIN}/app_center/v1.0/apps/install/`, // POST
    installTest: `${ADS_DOMAIN}/app_center/v1.0/apps/test/install/`, // POST
    uninstallProd: `${ADS_DOMAIN}/app_center/v1.0/apps/uninstall/`, // POST
    uninstallTest: `${ADS_DOMAIN}/app_center/v1.0/apps/test/uninstall/`, // POST
    listProd: `${ADS_DOMAIN}/app_center/v1.0/apps/info/get/`,
    listTest: `${ADS_DOMAIN}/app_center/v1.0/apps/test/info/get/`,
  },
};
